import { cn } from "@/lib/utils";

type Tier = 1 | 2 | 3;

interface TierSelectorProps {
  value: Tier | null;
  onChange: (tier: Tier | null) => void;
  disabled?: boolean;
}

const TIER_STYLES: Record<Tier, { active: string; inactive: string }> = {
  1: {
    active: "bg-emerald-600 text-white border-emerald-700",
    inactive: "bg-background text-emerald-700 border-emerald-300 hover:bg-emerald-50",
  },
  2: {
    active: "bg-amber-500 text-white border-amber-600",
    inactive: "bg-background text-amber-700 border-amber-300 hover:bg-amber-50",
  },
  3: {
    active: "bg-rose-500 text-white border-rose-600",
    inactive: "bg-background text-rose-700 border-rose-300 hover:bg-rose-50",
  },
};

export function TierSelector({ value, onChange, disabled }: TierSelectorProps) {
  return (
    <div className="flex gap-2">
      {([1, 2, 3] as const).map((tier) => {
        const isActive = value === tier;
        const style = TIER_STYLES[tier];
        return (
          <button
            key={tier}
            type="button"
            disabled={disabled}
            aria-pressed={isActive}
            aria-label={`Tier ${tier}`}
            onClick={() => onChange(isActive ? null : tier)}
            className={cn(
              "flex-1 h-10 rounded-md border text-sm font-semibold transition-colors",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              isActive ? style.active : style.inactive,
            )}
          >
            Tier {tier}
          </button>
        );
      })}
    </div>
  );
}
